<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <div class="h-input-group" v-width="350">
          <DatePicker v-model="params.start" style="width: 140px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 140px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <input type="text" v-model="params.keyword" v-width="200" placeholder="事由/付款人"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="primary" @click="add">新增无票收入</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="billList" :border="true" :loading="loading">
        <TableItem title="日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="事由" prop="reason" :width="200"></TableItem>
        <TableItem title="类型" prop="type" :width="120"></TableItem>
        <TableItem title="结算方式" prop="settleType" :width="100"></TableItem>
        <TableItem title="收入金额" :width="130" align="right">
          <template slot-scope="{data}">{{ data.amount | numFormat }}</template>
        </TableItem>
        <TableItem title="应交税费" :width="120" align="right">
          <template slot-scope="{data}">{{ data.taxAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="付款人" prop="payer" :width="150"></TableItem>
        <TableItem title="关联凭证" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue" v-if="data.voucherId">已生成</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="150">
          <div class="actions" slot-scope="{data}">
            <span @click="generateVoucher(data)" v-if="!data.voucherId">生成凭证</span>
            <span @click="edit(data)">编辑</span>
            <span @click="remove(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">无票收入</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="日期" prop="billDate">
          <DatePicker type="date" v-model="form.billDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
        <FormItem label="事由" prop="reason">
          <input type="text" v-model="form.reason">
        </FormItem>
        <FormItem label="收入类型" prop="type">
          <Select v-model="form.type" :datas="typeList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="结算方式" prop="settleType">
          <Select v-model="form.settleType" :datas="settleList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="收入金额" prop="amount">
          <NumberInput :min="0" v-model="form.amount"></NumberInput>
        </FormItem>
        <FormItem label="应交税费">
          <NumberInput :min="0" v-model="form.taxAmount"></NumberInput>
        </FormItem>
        <FormItem label="付款人" prop="payer">
          <input type="text" v-model="form.payer">
        </FormItem>
        <FormItem label="收入科目" prop="subjectId">
          <Select v-model="form.subjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="资金账户" prop="accountId">
          <Select v-model="form.accountId" :datas="accountList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="备注">
          <input type="text" v-model="form.remark">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

const emptyForm = {
  billDate: null,
  reason: '',
  type: '主营业务收入',
  settleType: '银行转账',
  amount: null,
  taxAmount: 0,
  payer: '',
  subjectId: null,
  accountId: null,
  remark: ''
};

export default {
  name: 'NonIncome',
  data() {
    return {
      billList: [],
      subjectList: [],
      accountList: [],
      typeList: [
        {id: '主营业务收入', name: '主营业务收入'},
        {id: '其他业务收入', name: '其他业务收入'},
        {id: '营业外收入', name: '营业外收入'}
      ],
      settleList: [
        {id: '现金', name: '现金'},
        {id: '银行转账', name: '银行转账'},
        {id: '支付宝', name: '支付宝'},
        {id: '微信', name: '微信'},
        {id: '其他', name: '其他'}
      ],
      params: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD'),
        keyword: ''
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['billDate', 'reason', 'type', 'settleType', 'amount', 'payer', 'subjectId', 'accountId']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadBase() {
      Promise.all([
        this.$api.setting.subject.voucherSelect({}),
        this.$api.funds.account.list()
      ]).then(results => {
        this.subjectList = results[0].data || [];
        this.accountList = results[1].data || [];
      });
    },
    loadList() {
      this.loading = true;
      this.$api.invoice.nonIncome.list(Object.assign({}, this.params, {
        page: this.pagination.page,
        size: this.pagination.size
      })).then(({data}) => {
        this.billList = data.results || data || [];
        this.pagination.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    add() {
      this.form = Object.assign({}, emptyForm, {billDate: moment().format('YYYY-MM-DD')});
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, emptyForm, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.loading = true;
      let data = Object.assign({}, this.form, {
        billDate: moment(this.form.billDate).format('YYYY-MM-DD')
      });
      this.$api.invoice.nonIncome[data.id ? 'update' : 'save'](data).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).catch(() => {
      }).finally(() => this.loading = false);
    },
    remove(data) {
      this.$Confirm('确认删除该无票收入？').then(() => {
        this.$api.invoice.nonIncome.delete(data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        });
      });
    },
    generateVoucher(data) {
      this.$Confirm('确认为该笔无票收入生成凭证？').then(() => {
        this.loading = true;
        this.$api.invoice.nonIncome.generateVoucher(data.id).then(() => {
          this.$Message('凭证生成成功~');
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      });
    }
  },
  mounted() {
    this.loadBase();
    this.loadList();
  }
}
</script>
